import { useState, useRef, useContext } from "react";
import { Notification } from "react-bulma-components";
import { useForm } from "react-hook-form"; 
import { SessionContext } from "../SessionContext";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import useFormPersist from 'react-hook-form-persist'

export default function Reg() {

    const { code = "" } = useParams();

    var responseOk = false;

    const [isLoggedIn, setIsLoggedIn] = useContext(SessionContext);
    const [isLoaded, setIsLoaded] = useState(true);
    const [msg, setMsg] = useState('');

    //const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const { register, handleSubmit, watch, formState: {errors}, setValue } = useForm();

    useFormPersist('form', {watch, setValue, exclude: ['password']});

    const password = useRef({});
    password.current = watch("pass", "");

    const create_new_user = data => {

    var formData = new FormData();
    formData.append('username',         data.login);
    formData.append('person_name',      data.person_name);
    formData.append('company_name',     data.company_name);
    formData.append('nick',             data.nick);
    formData.append('password',         data.pass);
    formData.append('code',             data.code);
    formData.append('kawa',             data.kawa);

    fetch('https://studiotworzenia.pl/reg.php', {
        crossDomain:true,
        method: 'POST',
        headers: {'Cache-Control': 'no-store'},
        body: formData,
    })
    .then((response) => {
        responseOk = response.ok;
        return response.json();
    })
    .then((result) => {
        if(responseOk){
            localStorage.setItem('user_code', result.Bearer);
            setIsLoggedIn(true);
            setIsLoaded(false);
            setMsg(<>
            <Notification color="success" >🎉 Zarejestrowano. Przejdź do zakładki Intro, aby rozpocząć.</Notification>
            <Notification color="success">Na twojego maila wysłaliśmy link aktywacyjny. Nie zapomnij, go kliknąć, aby wziąc udział w rankingu. Jeśli nie możesz znaleźć maila aktywacyjnego, sprawdź folder SPAM.</Notification></>);
          }
          else{
            setMsg(<Notification color="danger" >{result.message}</Notification>);
          }
    });
}//login()

if(isLoaded)
    return (
        /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
        <form onSubmit={handleSubmit(create_new_user)}>
        <h1 className="title">Zarejestruj się</h1>
        {/* register your input into the hook by invoking the "register" function */}
        <div className="field">
            <label className="label">Email</label>
            <div className="control">
                <input className="input" type="email" placeholder="Email przypisany do Infoshare" {...register("login", { required: "To pole jest wymagane." })} />
            </div>
            {errors.login && <p className="has-text-danger">{errors.login.message}</p>}
        </div>


        <div className="field">
            <label className="label">Ksywka</label>
            <div className="control">
                <input className="input" type="text" placeholder="Pseudonim do rankingu" {...register("nick", { required: "To pole jest wymagane.", minLength: {
            value: 2,
            message: "Minimalna długość ksywki to 2."
          }
        })} />
            </div>
            {errors.nick && <p className="has-text-danger">{errors.nick.message}</p>}
        </div>
        
        <div className="field">
            <label className="label">Hasło</label>
            <div className="control">
            <input className="input" type="password" placeholder="Min. 8 znaków" {...register("pass", { required: "To pole jest wymagane.", minLength: {
            value: 8,
            message: "Minimalna długość hasła to 8."
          }
        })} />
            </div>
            {errors.pass && <p className="has-text-danger">{errors.pass.message}</p>}
        </div>

        <div className="field">
            <label className="label">Powtórz hasło</label>
            <div className="control">
            <input className="input" type="password" placeholder="Wpisz ponownie hasło" {...register("password_repeat", {
          validate: value =>
            value === password.current || "Hasła nie są takie same."
        })} />
            </div>
            {errors.password_repeat && <p className="has-text-danger">{errors.password_repeat.message}</p>}
        </div>

        <div className="field">
            <label className="label">Twój unikalny kod do gry</label>
            <div className="control">
                <input className="input" type="text" defaultValue={code} {...register("code", { required: "To pole jest wymagane." })} />
            </div>
            <p class="help">Odwiedź stoisko JohnnyBros w celu odebrania swojego kodu</p>
            {errors.code && <p className="has-text-danger">{errors.code.message}</p>}
        </div>

        <p className="has-text-center my-5"><strong>Poniższe dane wymagane są do<br/>odbioru nagrody:</strong></p>

        <div className="field">
            <label className="label">Imię i nazwisko</label>
            <div className="control">
                <input className="input" type="text" placeholder="" {...register("person_name", { required: "To pole jest wymagane." })} />
            </div>
            {errors.person_name && <p className="has-text-danger">{errors.person_name.message}</p>}
        </div>

        <div className="field">
            <label className="label">Firma/Organizacja</label>
            <div className="control">
                <input className="input" type="text" placeholder="" {...register("company_name", { required: "To pole jest wymagane." })} />
            </div>
            {errors.company_name && <p className="has-text-danger">{errors.company_name.message}</p>}
        </div>

        <p className="has-text-center my-5"><strong>Pytanie dodatkowe:</strong></p>

        <div className="field my-3">
            <label className="label">Ile kanapek zjedzono w JohnnyBros od stycznia 2022 do końca września 2022?</label>
            <div className="control">
                <input className="input" type="text" placeholder="" {...register("kawa", )} />
            </div>
            <p class="help">Odpowiedz na pytanie i graj o dodatkową hulajnogę! Osoba, która ukończy całą grę (niezależnie od wyniku) i będzie najbliżej poprawnej odpowiedzi, otrzyma hulajnogę!</p>
        </div>

        <div className="field my-5">
             <label className="checkbox">
                <input className="checkbox mr-1" type="checkbox" {...register("terms", { required: "Konieczna jest akceptacja polityki prywatności oraz regulaminu." })} />
                Akceptuję <Link to="/policy">politykę prywatności</Link> oraz <Link to="/terms">regulamin gry</Link>.
            </label>
            {errors.terms && <p className="has-text-danger">{errors.terms.message}</p>}
        </div>
        
        <input className="button is-primary mb-4" type="submit" value="Zarejestruj"/>

        {msg}

        </form>
    );
    else
    {
        return (
        <>{msg}</>
        )
    }

}

